<template>
	<div class="mt-3 py-5">
		<b-container>

			<div class="content mb-auto">
				<div class="container-fluid sp-form-container">

					<!--Main layout-->
					<div class="container pl-3 pr-3">


            <div class="row justify-content-center">

                <div class="col-md-2">
                </div>
                <div class="col-md-8">
                    <template v-if="initError">
                      <div class="card">
                          <div class="card-body pr-3 pl-3">
                            <p>{{ errorMsg }}</p>
                          </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="card">
                          <div class="card-header">
                            <span v-if="String(sendForm.type) == '1'">ピアノ</span>
                            <span v-if="String(sendForm.type) == '2'">販売者</span>
                          への評価</div>
                          <div class="card-body pr-0 pl-0">

                            <template v-if="String(sendForm.type) == '2'">

                              <div class="row m-3">
                                <div class="form-group col-sm-12">
                                    <div class="col-sm-12 p-0">
                                      <p>販売者への評価をお願いします。（<span style="color: red;">※ここでの評価内容はウェブ上に公開されます。評価者はニックネームで表示されます</span>）</p>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="form-group col-sm-12">
                                    <div class="col-sm-12 p-0">
                                        <label class="control-label mb-3">購入に関する報告（この報告に限っては公開されず、販売者にも伝わりません）</label>
                                        <label class="control-label">ピアノ本体以外に購入したもの、その他コメントなど</label>
                                        <textarea  placeholder="イス、消音装置（例）" v-model="sendForm.comment" class="required form-control" rows="5" maxlength="1000" v-bind:class="{ error_input: sendForm.errors.comment.length > 0 }"></textarea>
                                        <div v-if="sendForm.errors.comment.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.comment" :key="index">{{ item }}</div>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">商品の満足度  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.product_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">掲載情報の正確性  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.infomation_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">スタッフの対応  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.staff_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">決済方法  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.payment_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">梱包  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.packing_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">配送  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.delivery_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="form-group col-sm-12">
                                    <div class="col-sm-12 p-0">
                                        <label class="control-label">評価の内容  <span class="required_mark">必須</span></label>
                                        <textarea  placeholder="" v-model="sendForm.contents" class="required form-control" rows="5" maxlength="1000" v-bind:class="{ error_input: sendForm.errors.contents.length > 0 }"></textarea>
                                        <div v-if="sendForm.errors.contents.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.contents" :key="index">{{ item }}</div>
                                        </div>
                                    </div>
                                </div>
                              </div>

                            </template>

                            <template v-if="String(sendForm.type) == '1'">

                              <div class="row m-3">
                                <div class="form-group col-sm-12">
                                    <div class="col-sm-12 p-0">
                                      <p>購入したピアノへの評価をお願いします。（<span style="color: red;">※ここでの評価内容はウェブ上に公開されます。評価者はニックネームで表示されます</span>）</p>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">響き・音色  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.tone_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">タッチ感  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.touch_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">つくりの良さ  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.made_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">デザイン  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.design_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">維持、管理のしやすさ  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in evaluation">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.maintain_evaluation" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">このピアノを使う人  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in who_use">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.who_use" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="col-sm-12 form-group">
                                    <div class="">
                                        <label for="" class="control-label">このピアノの使い方  <span class="required_mark">必須</span></label>
                                        <div class="">
                                          <template v-for="(item, index) in how_use">
                                            <label class="checkbox-inline p-3">
                                                <input type="radio" v-model="sendForm.how_use" :value="item.no">
                                                {{ item.name }}
                                            </label>
                                          </template>
                                        </div>
                                    </div>
                                </div>
                              </div>

                              <div class="row m-3">
                                <div class="form-group col-sm-12">
                                    <div class="col-sm-12 p-0">
                                        <label class="control-label">評価の内容  <span class="required_mark">必須</span></label>
                                        <textarea  placeholder="" v-model="sendForm.contents" class="required form-control" rows="5" maxlength="1000" v-bind:class="{ error_input: sendForm.errors.contents.length > 0 }"></textarea>
                                        <div v-if="sendForm.errors.contents.length > 0">
                                          <div class="error-text" v-for="(item, index) in sendForm.errors.contents" :key="index">{{ item }}</div>
                                        </div>
                                    </div>
                                </div>
                              </div>

                            </template>

                            <div class="row m-3">
                              <div class="form-group col-sm-12">
                                  <div class="b100 col-sm-12">
                                    <a href="javascript:void(0);" style="color: #575757;font-size: 1rem;width: 100%;color: #fefefe;background-color: #edbb4b;" class="m-0 p-2 btn" @click="sendReview">登録する</a><!-- :disabled="!isSendButton" -->
                                  </div>
                              </div>
                            </div>

                          </div>
                      </div>
                    </template>
                </div>
                <div class="col-md-2">
                </div>

            </div>


  				</div>

				</div>
			</div>

		</b-container>
	</div>
</template>

<script>

export default {
  name: 'Review',
  data () {
		const evaluation = [
      {"no":"5","name":"とてもよい"},
			{"no":"4","name":"よい"},
			{"no":"3","name":"ふつう"},
			{"no":"2","name":"あまりよくない"},
			{"no":"1","name":"よくない"},
		];
		const who_use = [
      {"no":"1","name":"子供"},
			{"no":"2","name":"大人"},
			{"no":"3","name":"家族共用"},
			{"no":"4","name":"演奏家"},
			{"no":"5","name":"生徒"},
			{"no":"6","name":"不特定多数"},
			{"no":"7","name":"その他"},
		];
		const how_use = [
      {"no":"1","name":"普段用"},
			{"no":"2","name":"ピアノレッスン用"},
			{"no":"3","name":"サロン演奏用"},
			{"no":"4","name":"コンサートホールなど公共施設用"},
			{"no":"5","name":"その他"},
		];

		return {
      evaluation,
      who_use,
      how_use,

      // 様々なエラー
      errorMsg: "",
      initError: false,

      sendForm: {
				errors: {
          // 販売者
          comment: [],
          product_evaluation: [],
          infomation_evaluation: [],
          staff_evaluation: [],
          payment_evaluation: [],
          packing_evaluation: [],
          delivery_evaluation: [],

          // 商品
          tone_evaluation: [],
          touch_evaluation: [],
          made_evaluation: [],
          design_evaluation: [],
          maintain_evaluation: [],
          who_use: [],
          how_use: [],

          contents: [],
        },
        // 販売者
        comment: null,
        product_evaluation: 3,
        infomation_evaluation: 3,
        staff_evaluation: 3,
        payment_evaluation: 3,
        packing_evaluation: 3,
        delivery_evaluation: 3,

        // 商品
        tone_evaluation: 3,
        touch_evaluation: 3,
        made_evaluation: 3,
        design_evaluation: 3,
        maintain_evaluation: 3,
        who_use: 1,
        how_use: 1,

        contents: null,
        type: null,
        orders_id: null,
        products_id: null,
      },
			isError: false,

    }
  },
  methods: {
    async checkReview() {
      this.$store.dispatch('review/check_review', {
        products_id: this.$route.params.products_id,
        orders_id: this.$route.params.orders_id,
        type: this.$route.params.type,
      }).then(res => {
        let review = res.data;
        console.log(review);
        if ( review['error'] ) {
          this.initError = true;
          this.errorMsg = review['msg'];
        }
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
    },
    async sendReviewExec() {
      this.$store.dispatch('review/post_review', {
        sendForm: this.sendForm,
      }).then(res => {
        // let order = res.data.orders;
        // console.log(order);
        alert('評価が完了しました');
        // location.href = '/mypage?page=6';
        this.$router.push({path: '/mypage', query: {page: 6}});
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
    },
    sendReview() {
      this.isError = false;
      this.sendForm.errors.comment = [];
      this.sendForm.errors.contents = [];

      if ( String(this.sendForm.type) == "1" ) { // ピアノ
        if (!this.sendForm.contents) {
          this.sendForm.errors.contents.push('評価の内容が入力されていません');
          this.isError = true;
        }
      } else if ( String(this.sendForm.type) == "2" ) { // 販売者
        // if (!this.sendForm.comment) {
        //   this.sendForm.errors.comment.push('ピアノ本体以外に購入したもの、その他コメントなどが入力されていません');
        //   this.isError = true;
        // }
        if (!this.sendForm.contents) {
          this.sendForm.errors.contents.push('評価の内容が入力されていません');
          this.isError = true;
        }
      }

      if (this.isError) {
        window.scrollTo({
          top: 0,
        });
      } else {
        this.sendReviewExec();
        return false;
      }
      return false;
    },
    // formCheck() {
    //   this.isSendButton = true;
    //   return false;
    // },
  },
  computed: {
  },
  created() {
    this.checkReview();
    this.sendForm.type = this.$route.params.type;
    this.sendForm.orders_id = this.$route.params.orders_id;
    this.sendForm.products_id = this.$route.params.products_id;
  },
  mounted() {
  },
  destroyed() {
  }

}
</script>

<style scoped>

/* PC */
@media screen and (max-width: 764px) {
  /* スマホ */
}

</style>



// WEBPACK FOOTER //
// src/components/Review.vue